
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString: string): string {
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("sv-SE", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }).format(date);
  } catch (error) {
    console.error("Error formatting date:", error);
    return dateString;
  }
}

export function formatDateTime(dateString: string): string {
  try {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("sv-SE", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    }).format(date);
  } catch (error) {
    console.error("Error formatting datetime:", error);
    return dateString;
  }
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return `${text.substring(0, maxLength)}...`;
}

export function getInitials(name: string): string {
  if (!name) return "";
  
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  
  return (
    parts[0].charAt(0).toUpperCase() + 
    parts[parts.length - 1].charAt(0).toUpperCase()
  );
}

export function formatTextWithBulletPoints(text: string): string {
  if (!text) return "";
  
  // Ensure proper bullet point formatting with double line breaks
  let formatted = text
    // First convert any asterisks to dashes for consistency
    .replace(/\*/g, "-")
    // Format dash bullet points with proper spacing
    .replace(/- */g, "- ")
    // Ensure bullet points start on a new line
    .replace(/([^\n])- /g, "$1\n- ")
    // Add double line breaks after each bullet point (except the last one)
    .replace(/(\n- [^\n]+)(?=\n- )/g, "$1\n")
    // Fix numbered lists
    .replace(/(\d+)\.\s*/g, "$1. ")
    // Ensure numbered items start on a new line
    .replace(/([^\n])(\d+)\. /g, "$1\n$2. ")
    // Add double line breaks after each numbered item (except the last one)
    .replace(/(\n\d+\. [^\n]+)(?=\n\d+\. )/g, "$1\n")
    // Trim extra whitespace
    .trim();
  
  return formatted;
}
